import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import {
  Icon,
  AlertTriangleIcon,
  CheckCircleIcon,
  XIcon,
  InfoIcon,
  AlertOctagonIcon,
} from 'components/shared/Icon/Icon'

import styles from './SnackbarContent.module.scss'

const icons = {
  info: (
    <Icon ariaLabel="info" className={styles.icon} icon={InfoIcon} size={24} />
  ),
  success: (
    <Icon
      ariaLabel="success"
      className={styles.icon}
      icon={CheckCircleIcon}
      size={24}
    />
  ),
  error: (
    <Icon
      ariaLabel="error"
      className={styles.icon}
      icon={AlertOctagonIcon}
      size={24}
    />
  ),
  warning: (
    <Icon
      ariaLabel="warning"
      className={styles.icon}
      icon={AlertTriangleIcon}
      size={24}
    />
  ),
}

export const SnackbarContent = ({ id, message, type, onDismiss }) => (
  <Box
    align="center"
    className={cx(styles.content, { [styles[type]]: Boolean(type) })}
    justify="center"
  >
    {icons[type]}
    <p className={styles.text}>{message}</p>
    {onDismiss ? (
      <button
        aria-label="hide"
        className={styles.button}
        onClick={() => onDismiss({ id, type })}
      >
        <Icon icon={XIcon} size={16} />
      </button>
    ) : null}
  </Box>
)
